import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  MultiProgressBarsChart,
  RiskStratificationChart,
  OverviewCard,
  DashedStandardDropdown,
  PageTitleAndSubTitle,
  HighCostClaimantsChart,
  MultiStackedColumnChart,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  CareQualityData,
  formatHighCostClaimants,
  formatPEPM,
  formatPMPM,
  formatTotalCost,
  formatTotalEnrolled,
  PEPM,
  PMPM,
  TotalCost,
  TotalEnrolled,
  TitleValueType,
  formatDiseasePrevalence,
  RiskStratificationCumulative,
  formatRiskStratificationBreakDown,
  formatRiskCost,
  formatRiskUtilization,
  formatTriggerConditions,
  CostTrendChartType,
  formatCostTrend,
  formatCostValues,
  formatMemberValues,
  getPmpmForCohorts,
  getPmpmValueForCohorts,
  getPepmForCohorts,
  getPepmValueForCohorts,
  formatUtilization,
} from '../../core-utils/helper-utils/summaryReportHelper';
import properties from '../../core-utils/properties';
import {
  formatDate,
  getToolText,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import summaryPageConstants from '../../core-utils/messages/summaryPageConstants';
import Loader from '../../_components/molecules/Loader';
import { observer } from 'mobx-react';
import { useStores } from '../../stores';
import { useNavigate } from 'react-router-dom';
import {
  DISEASE_PRELAVENCE,
  ENROLLMENT_METRICS,
  HIGH_COST_CLAIMS,
  MED_PHARMA,
  OTHER_PRESCRIPTION,
  PLAN_PERFORMANCE,
  PROCEDURE_UTILIZATION,
  RISK_PROFILING_BY_CHRONIC,
  RISK_PROFILING_BY_COST,
  RISK_PROFILING_BY_TRIGGER,
  RISK_PROFILING_BY_UTILIZATION,
  RX_UTILIZATION,
  SPECIALITY_DRUGS,
  SUMMARY,
} from '../../core-utils/routes';
import ScrollDown from '../../_components/atoms/ScrollDown';
import {
  patientAccessTheme,
  Typography,
} from '@HomaHealth/ui-component-library';
import { DATE_FORMAT } from '../../core-utils/messages/CommonConstants';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import highCostClaimantsMessages from '../../core-utils/messages/highCostClaimantsMessages';
import diseasePrevalencePageConstants from '../../core-utils/messages/diseasePrevalencePageConstants';
import utilizationRx from '../../core-utils/messages/utilizationRx';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import snackbarMessages from '../../core-utils/messages';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import FeatureAccessModal from '../../_components/organisms/FeatureAccessModal';
import { ICostBreakDownData } from '../UtilizationRx';
import componentConstants from '../../core-utils/messages/componentConstants';
import {
  formatCostBreakDownData,
  getLegendItem,
} from '../UtilizationRx/utilizationRxConstants';
import { patientAccessTheme as theme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import { utilizationmessages } from '../../core-utils/messages/utilizationProcedureConstants';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import DeepDiveCostTrendModal from '../../_components/organisms/DeepDiveCostTrendModal';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';

export interface SummaryPageProps {}

export const pageScrollDown = (elementId: string) => {
  const handleClickScrollDown = () => {
    const element = document.getElementById(elementId);
    if (element) {
      // 👇 Will scroll smoothly to the top of the given element id section
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        right: 0,
        bottom: 0,
        padding: '0px 16px 16px 0px',
      }}
    >
      <ScrollDown onClick={() => handleClickScrollDown()} showPageDown={true} />
    </div>
  );
};

const SummaryPage: React.FC<SummaryPageProps> = observer(({}) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
      width: '1182px',
    },
  });

  const { classes } = useStyles();

  const messages = summaryPageConstants.SUMMARY_PAGE;
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  const [loading, setLoading] = useState<boolean>(false);
  const [group2Loading, setGroup2Loading] = useState<boolean>(false);
  const [group3Loading, setGroup3Loading] = useState<boolean>(false);
  const summaryCardsStore = useStores().summaryCardsStore;
  const employerGroupStore = useStores().employerGroupStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const pathStore = useStores().pathStore;
  const loginPageStore = useStores().loginPageStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const { open, openModal, closeModal, isEditMode } = useCohortModal();
  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMembersCount(
        employerGroupStore.employerGroupResponseData.eg_nid,
        aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        employerGroupStore.employerGroupResponseData.max_claim_date,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const abortController = new AbortController();

  //states
  const [totalEligible, setTotalEligible] = useState<number>(0);
  const [totalEnrolled, setTotalEnrolled] = useState<TotalEnrolled>({
    totalCount: '',
    dependents: '',
    employees: '',
  });
  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });
  const [pmpm, setPMPM] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });
  const [pepm, setPEPM] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });
  const [
    riskStratificationCumulative,
    setRiskStratificationCumulative,
  ] = useState<RiskStratificationCumulative[]>([]);
  const [riskCost, setRiskCost] = useState<RiskStratificationCumulative[]>([]);
  const [riskUtilization, setRiskUtilization] = useState<
    RiskStratificationCumulative[]
  >([]);
  const [riskTriggerConditions, setRiskTriggerConditions] = useState<
    RiskStratificationCumulative[]
  >([]);
  const [
    CostTrendChartType,
    setCostTrendChartType,
  ] = useState<CostTrendChartType>({
    medicalClaimsData: [],
    medicalTotalPaid: [],
    medicalPlanPaid: [],
    medicalDeductible: [],
    medicalCopay: [],
    medicalCoinsurance: [],

    rxClaims: [],
    rxTotalPaid: [],
    rxPlanPaid: [],
    rxDeductible: [],
    rxCopay: [],
    rxCoinsurance: [],

    xAxisValues: [],
  });
  const [
    highCostClaimantsData,
    setHighCostClaimantsData,
  ] = useState<CareQualityData>({
    data: [],
    centerLabel: '',
  });
  const [diseasePrevalenceByMember, setDiseasePrevalenceByMember] = useState<
    TitleValueType[]
  >([]);
  const [diseasePrevalenceByCost, setDiseasePrevalenceByCost] = useState<
    TitleValueType[]
  >([]);
  const [
    diseasePrevalenceDropdownValue,
    setDiseasePrevalenceDropdownValue,
  ] = useState<string>('Cost');
  const [utilizationByMember, setUtilizationByMember] = useState<
    TitleValueType[]
  >([]);
  const [utilizationByCost, setUtilizationByCost] = useState<TitleValueType[]>(
    [],
  );
  const [
    utilizationDropdownValue,
    setUtilizationDropdownValue,
  ] = useState<string>('Cost');
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);
  const [costTrendModalOpen, setCostTrendModalOpen] = useState<boolean>(false);

  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );

  const [
    costBreakDownData,
    setCostBreakDownData,
  ] = useState<ICostBreakDownData>({
    medPharmaDrugsCost: 0,
    specialityDrugsCost: 0,
    otherPrescriptionDrugsCost: 0,
    totalCost: 0,
  });

  const navigate = useNavigate();
  const pageConstants = componentConstants.PAGES.UTILIZATION_RX;
  const screenName = allScreenLabel;
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        '',
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const setSummaryCardsStore = () => {
    summaryCardsStore.addTotalEligible(totalEligible);
    summaryCardsStore.addTotalEnrolled(
      totalEnrolled.totalCount,
      totalEnrolled.dependents,
      totalEnrolled.employees,
    );
    summaryCardsStore.addTotalCost(
      totalCost.totalCost,
      totalCost.totalRx,
      totalCost.totalMedical,
    );
    summaryCardsStore.addPEPM(pepm.pepm, pepm.pepmPercentage, pepm.increment);
    summaryCardsStore.addPMPM(pmpm.pmpm, pmpm.pmpmPercentage, pmpm.increment);
  };
  useEffect(() => {
    setSummaryCardsStore();
  }, [pmpm]);

  const getUrlByType = (type: string | undefined) => {
    switch (type) {
      case 'Chronic':
        return RISK_PROFILING_BY_CHRONIC;
      case 'Trigger Conditions':
        return RISK_PROFILING_BY_TRIGGER;
      case 'Cost':
        return RISK_PROFILING_BY_COST;
      case 'Utilization':
        return RISK_PROFILING_BY_UTILIZATION;
      default:
        return RISK_PROFILING_BY_CHRONIC;
    }
  };

  const getTypeOfScreen = (type: string | undefined) => {
    switch (type) {
      case 'Chronic':
        return 'chronic';
      case 'Trigger Conditions':
        return 'trigger';
      case 'Cost':
        return 'cost';
      case 'Utilization':
        return 'utilization';
      default:
        return 'chronic';
    }
  };

  const storeMemberIds = (memberIds: string[], tier: string, type?: string) => {
    summaryCardsStore.addMemberIds(memberIds);
    navigate(getUrlByType(type), {
      state: {
        isRiskStrat: true,
        memberIds,
        tier: tier,
        type: getTypeOfScreen(type),
        count: memberIds.length,
      },
    });
  };

  const formatRiskStratificationCumulative = (data: any) => {
    const riskStratificationCumulative: RiskStratificationCumulative[] = [];
    data?.map((item: any) => {
      const eachValue: RiskStratificationCumulative = {
        tier: '',
        count: 0,
        memberIds: [],
        handleClick: () => {},
      };
      eachValue.tier = item._id;
      eachValue.count = item.member_unique_id_list.length;
      eachValue.memberIds = item.member_unique_id_list;
      eachValue.handleClick = () => {
        navigate(getUrlByType('Chronic'), {
          state: {
            isRiskStrat: true,
            memberIds: item.member_unique_id_list,
            tier: item._id,
            type: 'chronic',
            count: item.member_unique_id_list.length,
          },
        });
      };
      riskStratificationCumulative.push(eachValue);
    });

    const tiers = ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4', 'Tier 5'];
    const formattedData = tiers.map((tierName) => {
      const tierData = riskStratificationCumulative.find(
        (tier) => tier.tier === tierName,
      );
      return (
        tierData || {
          tier: tierName,
          count: 0,
          memberIds: [],
          handleClick: () => {},
        }
      );
    });
    return formattedData;
  };

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  const getTotalEligible = () => {
    return axios.post(
      properties.aiqBaseUrl + properties.summaryBaseUrl,
      {
        ...payload,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      },
      { signal: abortController.signal },
    );
  };

  const getPMPMAndPepm = () => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.summaryBaseUrl +
        properties.pmpmAndPepm,
      {
        startDate:
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
        endDate:
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      },
      { signal: abortController.signal },
    );
  };

  const getRiskStratification = () => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.summaryBaseUrl +
        properties.riskStratification,
      {
        ...payload,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      },
      { signal: abortController.signal },
    );
  };

  const getRiskStratificationData = () => {
    return formatRiskStratificationBreakDown(
      riskCost,
      riskUtilization,
      riskTriggerConditions,
    );
  };

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      const apiResponses = {
        title_1: {
          totalEligible,
          totalEnrolled,
          totalCost,
          pmpm,
          pepm,
        },

        title_2: {
          highCostClaimants: highCostClaimantsData,
          riskStratification: getRiskStratificationData(),
        },

        title_3: {
          costTrend: CostTrendChartType,
          costBreakdown: costBreakDownData,
        },

        title_4: {
          diseasePrevalenceByCost,
          diseasePrevalenceByMember,
        },

        title_5: {
          utilizationByCost,
          utilizationByMember,
        },
      };

      let resultArray = [];

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.SUMMARY, // ✅ use your screen name
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        resultArray = response?.data?.data?.data?.result || [];

        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
        console.error('AI Summary API failed:', apiError);

        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error) {
      console.error('Unexpected Error:', error);

      handleOpenSnackBar(
        'Something went wrong. Please try again.',
        'error',
        6000,
      );

      setAiSummaryData([]);
    } finally {
      setAiLoading(false);
    }
  };

  const getCostTrend = () => {
    return axios.post(
      properties.aiqBaseUrl + properties.summaryBaseUrl + properties.costTrend,
      {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      },
      { signal: abortController.signal },
    );
  };

  const getHighCostClaimants = () => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.summaryBaseUrl +
        properties.highCostClaimants,
      {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      },
      { signal: abortController.signal },
    );
  };

  const getDiseasePrevalenceUsageByCost = () => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.memberSummaryBaseUrl +
        properties.diseasePrevalenceByCost,
      {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        limit: 7,
      },
      { signal: abortController.signal },
    );
  };

  const getDiseasePrevalenceByMember = () => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.memberSummaryBaseUrl +
        properties.diseasePrevalenceByMember,
      {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        limit: 7,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      },
      { signal: abortController.signal },
    );
  };

  const getUtilizationByCost = () => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.summaryBaseUrl +
        properties.utilizationByCost,
      {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        limit: 7,
      },
      { signal: abortController.signal },
    );
  };

  const getUtilizationByMember = () => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.summaryBaseUrl +
        properties.utilizationByMember,
      {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        limit: 7,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      },
      { signal: abortController.signal },
    );
  };

  const getCostBreakDownChartData = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.costBreakDown;
    const body = {
      ...payload,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };
    return axios.post(baseUrl, body, { signal: abortController.signal });
  };

  const [
    diseasePrevalenceLoading,
    setDiseasePrevalenceLoading,
  ] = useState<boolean>(false);
  const handleTopDiseasePrevalence = (event: any) => {
    const value: string = event.target.value as string;
    setDiseasePrevalenceDropdownValue(value);
    if (value === 'Member') {
      if (diseasePrevalenceByMember.length === 0) {
        setDiseasePrevalenceLoading(true);
        getDiseasePrevalenceByMember()
          .then((response) => {
            setDiseasePrevalenceByMember(
              formatDiseasePrevalence(
                response?.data?.data?.topDiagnosis,
                'member',
                7,
              ),
            );
            setDiseasePrevalenceLoading(false);
          })
          .catch((error) => {
            handleOpenSnackBar(
              error.response?.data?.error ??
                snackbarMessages.SOMETHING_WENT_WRONG,
              'error',
              8000,
            );
          });
      }
    }
  };

  const [utilizationLoading, setUtilizationLoading] = useState<boolean>(false);
  const handleUtilization = (event: any) => {
    const value: string = event.target.value as string;
    setUtilizationDropdownValue(value);
    if (value === 'Member') {
      if (utilizationByMember.length === 0) {
        setUtilizationLoading(true);
        getUtilizationByMember()
          .then((response) => {
            setUtilizationByMember(
              formatUtilization(response?.data?.data?.topService, 'member', 7),
            );
            setUtilizationLoading(false);
          })
          .catch((error) => {
            handleOpenSnackBar(
              error.response?.data?.error ??
                snackbarMessages.SOMETHING_WENT_WRONG,
              'error',
              8000,
            );
          });
      }
    }
  };

  const recommendedTabStore = useStores().recommendedTabStore;
  const getAllCharts = async () => {
    setLoading(true);
    setGroup2Loading(true);
    setGroup3Loading(true);

    isPlanDatesFetched &&
      (await Promise.allSettled([
        getTotalEligible(),
        getPMPMAndPepm(),
        getRiskStratification(),
        getHighCostClaimants(),
      ])
        .then((responses: any) => {
          responses.map((res: any) => {
            if (res.status !== 'fulfilled') {
              handleOpenSnackBar(res.reason.message, 'error', 6000);
            }
          });

          if (responses[0]?.status === 'fulfilled') {
            summaryCardsStore.addResponse(responses[0]?.value?.data?.data);
            summaryCardsStore.addCostValues(
              formatCostValues(responses[0]?.value?.data?.data),
            );
            summaryCardsStore.addMemberValues(
              formatMemberValues(responses[0]?.value?.data?.data),
            );
            const costData: TotalCost = formatTotalCost(
              responses[0]?.value?.data?.data,
            );
            summaryCardsStore.addTotalCost(
              costData.totalCost,
              costData.totalRx,
              costData.totalMedical,
            );
            setTotalEligible(
              responses[0]?.value?.data?.data?.totalEligibleCount,
            );
            setTotalEnrolled(
              formatTotalEnrolled(responses[0]?.value?.data?.data),
            );
            setTotalCost(formatTotalCost(responses[0]?.value?.data?.data, 2));
          }
          if (responses[1]?.status === 'fulfilled') {
            setPMPM(formatPMPM(responses[1]?.value?.data?.data?.pmpm));
            setPEPM(formatPEPM(responses[1]?.value?.data?.data?.pepm));
          }
          if (responses[2]?.status === 'fulfilled') {
            setRiskStratificationCumulative(
              formatRiskStratificationCumulative(
                responses[2]?.value?.data?.data.riskPrevalence,
              ),
            );
            setRiskCost(
              formatRiskCost(
                responses[2]?.value?.data?.data.riskCost,
                storeMemberIds,
              ),
            );
            setRiskUtilization(
              formatRiskUtilization(
                responses[2]?.value?.data?.data.riskUtilization,
                storeMemberIds,
              ),
            );
            setRiskTriggerConditions(
              formatTriggerConditions(
                responses[2]?.value?.data?.data.riskTrigger,
                storeMemberIds,
              ),
            );
          }
          if (responses[3]?.status === 'fulfilled') {
            setHighCostClaimantsData(
              formatHighCostClaimants(responses[3]?.value?.data?.data),
            );
          }
        })
        .then(async () => {
          setLoading(false);
          await Promise.allSettled([getCostTrend()])
            .then((responses: any) => {
              responses.map((res: any) => {
                if (res.status !== 'fulfilled') {
                  handleOpenSnackBar(res.reason.message, 'error', 6000);
                }
              });

              if (responses[0]?.status === 'fulfilled') {
                setCostTrendChartType(
                  formatCostTrend(responses[0]?.value?.data?.data?.costTrend),
                );
              }
            })
            .then(async () => {
              setGroup2Loading(false);
              await Promise.allSettled([
                getDiseasePrevalenceUsageByCost(),
                getUtilizationByCost(),
                getCostBreakDownChartData(),
              ])

                .then((responses: any) => {
                  responses.map((res: any) => {
                    if (res.status !== 'fulfilled') {
                      handleOpenSnackBar(res.reason.message, 'error', 6000);
                    }
                  });

                  if (responses[0]?.status === 'fulfilled') {
                    setDiseasePrevalenceByCost(
                      formatDiseasePrevalence(
                        responses[0]?.value?.data?.data?.topDiagnosis,
                        'cost',
                        7,
                      ),
                    );
                  }
                  if (responses[1]?.status === 'fulfilled') {
                    setUtilizationByCost(
                      formatUtilization(
                        responses[1]?.value?.data?.data?.topService,
                        'cost',
                        7,
                      ),
                    );
                  }
                  if (responses[2]?.status === 'fulfilled') {
                    setCostBreakDownData(
                      formatCostBreakDownData(responses[2]?.value?.data?.data),
                    );
                  }
                })

                .then(() => {
                  setGroup3Loading(false);
                });
            });
        }));

    setLoading(false);
  };

  useEffect(() => {
    if (isInitializing) {
      return;
    }

    getAllCharts();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);
  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  const [loader] = useState<any>(<Loader />);

  const SummaryCards = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
      },
      queryIconGrid: {
        padding: '10px 0px 10px 22px',
      },
      queryDataOverallGrid: {
        margin: '10px 10px 10px 0px',
        height: '44px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
        width: '1176px',
        borderRadius: '4px',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataTypography: {
        padding: '10px 10px',
        height: '44px',
        borderRight: '1px solid #DADEEF',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataGrid: {
        maxWidth: '400px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '60px',
      },
      editQueryGrid: {
        padding: '10px 40px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
      },
      tooltip: {
        backgroundColor: patientAccessTheme.palette.grey[900],
        padding: '10px',
        fontSize: '13px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '16px',
        color: patientAccessTheme.palette.status.white,
      },
      arrow: {
        color: patientAccessTheme.palette.grey[900],
        marginLeft: '50px',
      },
      popper: {
        marginTop: '-20px',
        marginLeft: '-20px',
      },
      clearFilterGrid: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingRight: '12px',
        cursor: 'pointer',
        gap: 4,
        backgroundColor: '#E5E9F0',
        padding: 10,
      },
    });

    const BreadCrumbGenerator = (navigateTo: string) => {
      return [
        [
          'text',
          summaryPageConstants.SUMMARY_PAGE.TITLE,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            pathStore.clearPath();
            navigate(SUMMARY);
          },
        ],
        [
          'text',
          navigateTo,
          {
            color: patientAccessTheme.palette.text.highemphasis,
            fontWeight: 600,
          },
        ],
      ];
    };

    const highCostClaimantsClickHere = () => {
      pathStore.setPath(
        BreadCrumbGenerator(
          highCostClaimantsMessages.HIGH_COST_CLAIMANTS_PAGE.TITLE,
        ),
      );
      navigate(HIGH_COST_CLAIMS);
    };

    const topDiseasePrevalence = () => {
      pathStore.setPath(
        BreadCrumbGenerator(
          diseasePrevalencePageConstants.DISEASE_PREVALENCE_PAGE.TITLE,
        ),
      );
      navigate(DISEASE_PRELAVENCE);
    };
    const topUtilization = () => {
      pathStore.setPath(BreadCrumbGenerator(utilizationmessages.page.title));
      navigate(PROCEDURE_UTILIZATION);
    };
    const pushToEnrollemntMetrics = () => {
      navigate(ENROLLMENT_METRICS);
    };
    const pushToPlanPerformance = () => {
      navigate(PLAN_PERFORMANCE);
    };
    const legendItems = (
      <>
        {getLegendItem('#08C7B4', 'Medpharma Drugs', true, () => {
          navigate(MED_PHARMA);
        })}
        {getLegendItem(
          theme.palette.warning[500] ?? '',
          'Speciality Drugs',
          true,
          () => {
            navigate(SPECIALITY_DRUGS);
          },
        )}
        {getLegendItem(
          theme.palette.primary[300] ?? '',
          'Non-Speciality Drugs',
          true,
          () => {
            navigate(OTHER_PRESCRIPTION);
          },
        )}
      </>
    );

    const CostBreakdownChartProps = (
      medPharmaCost: number,
      specialityCost: number,
      otherCost: number,
      totalCost: number,
    ) => {
      return {
        data: [
          {
            value: medPharmaCost,
            label: pageConstants.DRUG_TYPES.MEDPHARMA,
            color: '#08C7B4',
            toolText: getToolText(medPharmaCost),
          },
          {
            value: specialityCost,
            label: pageConstants.DRUG_TYPES.SPECIALITY,
            color: theme.palette.warning[500],
            toolText: getToolText(specialityCost),
          },
          {
            value: otherCost,
            label: pageConstants.DRUG_TYPES.OTHER,
            color: theme.palette.primary[300],
            toolText: getToolText(otherCost),
          },
        ],
        centerLabel: `$${numFormatterWithSuffix(totalCost)}`,
        centerLabelBold: true,
        centerLabelFontSize: '14',
        cardHeight: '405px',
        cardWidth: '376px',
        title: 'Drug Utilization',
        subtitle: 'To see more about the Drug usage',
        clickHere: 'Click Here',
        tooltip: '',
        showSearchDB: false,
        customLegend: (
          <Grid
            container
            sx={{
              justifyContent: 'center',
            }}
          >
            {legendItems}
          </Grid>
        ),
        decimals: '2',
        formatNumberScale: '1',
        handleClick: () => {
          pathStore.setPath(
            BreadCrumbGenerator(utilizationRx.titleAndSubtitle.title),
          );
          navigate(RX_UTILIZATION);
        },
        numberPrefix: '$',
      };
    };

    const { classes } = useStyles();
    const messages = summaryPageConstants.SUMMARY_PAGE.SUMMARY_CARDS;

    return (
      <Grid container className={classes.root}>
        <CohortFilterBar />
        <Grid style={{ display: 'flex', marginBottom: '29px' }}>
          <Grid style={{ marginRight: '25px' }}>
            <OverviewCard
              title={messages.TOTAL_ENROLLED}
              value={totalEnrolled?.totalCount}
              isMultiValued={true}
              rightLabelValues={[
                ['Employees', totalEnrolled?.employees],
                ['Dependents', totalEnrolled?.dependents],
              ]}
              rootStyles={{
                width: '315px',
                height: '100px',
              }}
              labelsMinWidth="72px"
              showClickHere
              handleClickHere={pushToEnrollemntMetrics}
            />
          </Grid>

          <Grid style={{ marginRight: '25px' }}>
            <OverviewCard
              title={messages.TOTAL_COST}
              value={totalCost?.totalCost}
              isMultiValued={true}
              rightLabelValues={[
                ['Medical', totalCost?.totalMedical],
                ['Rx', totalCost?.totalRx],
              ]}
              rootStyles={{
                width: '315px',
                height: '100px',
              }}
              showClickHere
              handleClickHere={pushToPlanPerformance}
            />
          </Grid>

          <Grid style={{ marginRight: '25px' }}>
            <OverviewCard
              title={messages.PMPM}
              topLabelValues={getPmpmForCohorts(
                pmpm,
                cohortDetailsStore.claimIdList,
                cohortDetailsStore.memberUniqueIdList,
              )}
              value={getPmpmValueForCohorts(
                pmpm,
                cohortDetailsStore.claimIdList,
                cohortDetailsStore.memberUniqueIdList,
              )}
              rootStyles={{
                width: '238px',
                height: '100px',
              }}
              showClickHere
              handleClickHere={pushToPlanPerformance}
            />
          </Grid>

          <Grid style={{ marginRight: '25px' }}>
            <OverviewCard
              title={messages.PEPM}
              topLabelValues={getPepmForCohorts(
                pepm,
                cohortDetailsStore.claimIdList,
                cohortDetailsStore.memberUniqueIdList,
              )}
              value={getPepmValueForCohorts(
                pepm,
                cohortDetailsStore.claimIdList,
                cohortDetailsStore.memberUniqueIdList,
              )}
              rootStyles={{
                width: '238px',
                height: '100px',
              }}
              showClickHere
              handleClickHere={pushToPlanPerformance}
            />
          </Grid>
        </Grid>
        <Grid style={{ display: 'flex', marginBottom: '28px' }}>
          <RiskStratificationChart
            cardHeight="418px"
            riskStratificationChartColumns={
              getRiskStratificationData().riskStratificationColumns
            }
            riskStratificationChartRows={
              getRiskStratificationData().riskStratificationRows
            }
            riskStratificationChartData={
              getRiskStratificationData().riskStratificationData
            }
            riskSummaryData={riskStratificationCumulative}
            toolTipStyles={{ textAlign: 'justify' }}
            riskStatificationCumulativeLabels={
              messages.RISK_STRATIFICATION_CUMULATIVE_LABELS
            }
            riskStratificationLabels={messages.RISK_STRATIFICATION_LABELS}
            toggleStyles={{
              toggleLeftStyles: {
                border: 'none',
                borderRight:
                  '1px solid ' + patientAccessTheme.palette.grey[300],
                width: '150px',
              },
              toggleRightStyles: {
                border: 'none',
                borderLeft: '1px solid ' + patientAccessTheme.palette.grey[300],
                width: '150px',
              },
            }}
          />
          <Grid
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '24px',
            }}
          >
            <HighCostClaimantsChart
              cardHeight="418px"
              data={highCostClaimantsData?.data}
              centerLabel={highCostClaimantsData?.centerLabel}
              handleClick={highCostClaimantsClickHere}
              decimals="2"
              toolTipStyles={{ textAlign: 'justify' }}
              formatNumberScale="1"
              numberPrefix="$"
            />
          </Grid>
        </Grid>
        {group2Loading ? (
          loader
        ) : (
          <Grid>
            <Grid style={{ display: 'flex', marginBottom: '28px' }}>
              <MultiStackedColumnChart
                title="Total Cost Trend (Plan Paid + Member Paid)"
                subTitle="Click to view full historical trend."
                handleClickHere={() => setCostTrendModalOpen(true)}
                widthOfCard="1182px"
                widthOfChart={1020}
                heightOfChart={290}
                heightOfCard="383px"
                category={CostTrendChartType?.xAxisValues}
                dataSet={[
                  {
                    dataset: [
                      {
                        seriesname: 'Medical Plan Paid',
                        color: '#2B376A',
                        data: CostTrendChartType?.medicalPlanPaid,
                      },
                      {
                        seriesname: 'Medical Deductible',
                        color: '#6C7DC0',
                        data: CostTrendChartType?.medicalDeductible,
                      },
                      {
                        seriesname: 'Medical Copay',
                        color: '#919DD0',
                        data: CostTrendChartType?.medicalCopay,
                      },
                      {
                        seriesname: 'Medical Coinsurance',
                        color: '#B5BEDF',
                        data: CostTrendChartType?.medicalCoinsurance,
                      },
                      {
                        seriesname: 'Rx Plan Paid',
                        color: '#FF8A53',
                        data: CostTrendChartType?.rxPlanPaid,
                      },
                      {
                        seriesname: 'Rx Deductible',
                        color: '#FC8851',
                        data: CostTrendChartType?.rxDeductible,
                      },
                      {
                        seriesname: 'Rx Copay',
                        color: '#FF9B6D',
                        data: CostTrendChartType?.rxCopay,
                      },
                      {
                        seriesname: 'Rx Coinsurance',
                        color: '#FFAA82',
                        data: CostTrendChartType?.rxCoinsurance,
                      },
                    ],
                  },
                ]}
              />
            </Grid>
            {group3Loading ? (
              loader
            ) : (
              <Grid style={{ display: 'flex' }}>
                <Grid style={{ marginRight: '24px' }}>
                  <MultiProgressBarsChart
                    title={messages.DISEASE_PREVALENCE.TITLE}
                    subTitle={messages.DISEASE_PREVALENCE.SUB_TITLE}
                    dataArray={
                      diseasePrevalenceDropdownValue === 'Cost'
                        ? diseasePrevalenceByCost
                        : diseasePrevalenceByMember
                    }
                    valueSuffix="%"
                    showClickHere
                    handleClick={topDiseasePrevalence}
                    dropdownElement={
                      <DashedStandardDropdown
                        height="24px"
                        value={diseasePrevalenceDropdownValue}
                        options={messages.DISEASE_PREVALENCE.DROPDOWN_OPTIONS}
                        displayValue={
                          messages.DISEASE_PREVALENCE.DROPDOWN_OPTIONS
                        }
                        handleChange={handleTopDiseasePrevalence}
                      />
                    }
                    height="404px"
                    bodyHeight="300px"
                    isLoading={diseasePrevalenceLoading}
                  />
                </Grid>

                <Grid style={{ marginRight: '24px' }}>
                  <MultiProgressBarsChart
                    title={messages.UTILIZATION_PER_100.TITLE}
                    subTitle={messages.UTILIZATION_PER_100.SUB_TITLE}
                    dataArray={
                      utilizationDropdownValue === 'Cost'
                        ? utilizationByCost
                        : utilizationByMember
                    }
                    valueSuffix="%"
                    showClickHere
                    handleClick={topUtilization}
                    dropdownElement={
                      <DashedStandardDropdown
                        height="24px"
                        value={utilizationDropdownValue}
                        options={messages.UTILIZATION_PER_100.DROPDOWN_OPTIONS}
                        displayValue={
                          messages.UTILIZATION_PER_100.DROPDOWN_OPTIONS
                        }
                        handleChange={handleUtilization}
                      />
                    }
                    height="404px"
                    bodyHeight="300px"
                    isLoading={utilizationLoading}
                  />
                </Grid>

                {/* <Grid style={{ marginRight: '24px' }}>
                  <HighCostClaimantsChart
                    data={formatUtilizationPer100(utilizationPer100).chartData}
                    centerLabel={''}
                    cardHeight={'405px'}
                    cardWidth={'376px'}
                    title={messages.UTILIZATION_PER_100.TITLE}
                    subtitle={messages.UTILIZATION_PER_100.SUB_TITLE}
                    handleClick={topUtilization}
                    tooltip={''}
                    showSearchDB={false}
                    customLegend={
                      <Grid container justifyContent="center">
                        {
                          formatUtilizationPer100(utilizationPer100, false)
                            .labelsData
                        }
                      </Grid>
                    }
                    decimals={'2'}
                    formatNumberScale={'1'}
                    numberSuffix="%"
                  />
                </Grid> */}

                <>
                  <HighCostClaimantsChart
                    {...CostBreakdownChartProps(
                      costBreakDownData.medPharmaDrugsCost,
                      costBreakDownData.specialityDrugsCost,
                      costBreakDownData.otherPrescriptionDrugsCost,
                      costBreakDownData.totalCost,
                    )}
                  />
                </>
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
    );
  };

  const isPageLoading = isPlanDatesLoading || loading || isInitializing;

  return (
    <>
      {isPageLoading ? (
        loader
      ) : (
        <div>
          <Grid container className={classes.root}>
            <Grid
              style={{
                marginBottom: '18px',
                width: '1182px',
                position: 'relative',
              }}
            >
              <PageTitleAndSubTitle
                title={messages.TITLE}
                subTitle={messages.SUBTITLE.PART1}
                subTitleStartPeriod={formatDate(
                  aggregationParameter === 'paid'
                    ? paidStartDate
                    : incurredStartDate,
                  'MMM YYYY',
                  DATE_FORMAT,
                )}
                subTitleMiddleString={messages.SUBTITLE.PART2}
                subTitleEndPeriod={formatDate(
                  aggregationParameter === 'paid'
                    ? paidEndDate
                    : incurredEndDate,
                  'MMM YYYY',
                  DATE_FORMAT,
                )}
                subTitleEndString={messages.SUBTITLE.PART3}
                showDownloadButton={true}
                // downloadButtonAction={() => setOpenReportsModal(true)}
                downloadButtonAction={() => {
                  downloadPdf(
                    'summaryReport',
                    {
                      employer:
                        employerGroupStore?.employerGroupResponseData
                          ?.employer_group_name,
                      member_unique_id_list: [],
                      claim_id_list: [],
                      maxClaimDate:
                        employerGroupStore?.employerGroupResponseData
                          ?.max_claim_date,
                      ...payload,
                    },
                    handleOpenSnackBar,
                    'open',
                  );
                  handleOpenSnackBar(
                    snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                    'info',
                    6000,
                  );
                }}
                showQueryDataButton={checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )}
                queryButtonText={
                  cohortDetailsStore.cohortDetailsList?.length > 0 &&
                  cohortDetailsStore.cohortDetailsList[0].category !== ''
                    ? 'Edit Cohort'
                    : 'Add Cohort'
                }
                queryDataAction={() => {
                  if (
                    checkUserAccess(
                      UserAccessConstants.COHORT_DETAILS,
                      loginPageStore.userResponse.role.name,
                      loginPageStore.userFeatures,
                    )
                  ) {
                    openModal();
                  } else {
                    setOpenFeatureAccessModal(true);
                  }
                }}
                showAskAi={true}
                askAiAction={handleAskAi}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '-1px',
                  left: '85px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  for
                </Typography>
                <DateFilter />
              </div>

              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>

            <Grid>
              {selectedTabIndex === 0 && <SummaryCards />}
              {selectedTabIndex === 1 && (
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                />
              )}
            </Grid>

            <div id="scroll-top-element"></div>
          </Grid>
          {pageScrollDown('scroll-top-element')}
        </div>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      {openReportsModal && (
        <ReportsModal
          open={openReportsModal}
          setOpen={setOpenReportsModal}
          startDate={incurredStartDate}
          endDate={incurredEndDate}
        />
      )}
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
      <FeatureAccessModal
        open={openFeatureAccessModal}
        handleClose={() => {
          setOpenFeatureAccessModal(false);
        }}
        access={checkUserAccess(
          UserAccessConstants.COHORT_DETAILS,
          loginPageStore.userResponse.role.name,
          loginPageStore.userFeatures,
        )}
      ></FeatureAccessModal>
      {costTrendModalOpen && (
        <DeepDiveCostTrendModal
          open={costTrendModalOpen}
          setOpen={setCostTrendModalOpen}
          handleOpenSnackBar={handleOpenSnackBar}
          selectedTrend={{
            value: 'Overall',
            total_paid_amount: totalCost.totalCost,
          }}
          payload={payload}
          isIncurredDate={isIncurredDate}
          isPaidDate={isPaidDate}
        />
      )}
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData || []}
        loading={aiLoading}
      />
    </>
  );
});

export default SummaryPage;
